import { computed, ComputedRef, MaybeRefOrGetter, toValue } from "vue";
import {
  DS_INLINE_TOKEN_GROUP_EDGE,
  DSInlineTokenGroupEdge,
} from "@/src/design_system/data_display/inline_token/types/props";
import { DSInputToken } from "@/src/design_system/form_elements/token_input/types";

const isSameGroup = (token: DSInputToken, neighbour?: DSInputToken): boolean =>
  !!token.group && token.group === neighbour?.group;

const getGroupEdge = (tokens: DSInputToken[], index: number): DSInlineTokenGroupEdge => {
  const token = tokens[index];
  const joinsPrevious = isSameGroup(token, tokens[index - 1]);
  const joinsNext = isSameGroup(token, tokens[index + 1]);

  if (joinsPrevious && joinsNext) {
    return DS_INLINE_TOKEN_GROUP_EDGE.Middle;
  }
  if (joinsNext) {
    return DS_INLINE_TOKEN_GROUP_EDGE.Start;
  }
  if (joinsPrevious) {
    return DS_INLINE_TOKEN_GROUP_EDGE.End;
  }

  return DS_INLINE_TOKEN_GROUP_EDGE.Solo;
};

export const useTokenInputGroups = (tokens: MaybeRefOrGetter<DSInputToken[]>): ComputedRef<DSInlineTokenGroupEdge[]> =>
  computed(() => {
    const list = toValue(tokens);

    return list.map((_, index) => getGroupEdge(list, index));
  });
